import {
    ExternalFinancialEntityType,
    feConfigs,
} from '../../financialEntities';

export const getManualAddAccountTypeItems = (
    types: ExternalFinancialEntityType[]
) => {
    return types
        .map((type) => ({ type, ...feConfigs[type] }))
        .sort((a, b) => a.title.localeCompare(b.title));
};
